module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/90/assets/images/c6149a6ed0324d3faa8a7b5c04a995e5.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Bronze/Bronze2.svg
// module id = 0loc
// module chunks = 1